export function getDemoTradeDisplayId(trade: any): string | null {
  const candidates = [
    trade?.tradeId,
    trade?.storageId,
    trade?.originalId,
    trade?.orderId,
    ...(Array.isArray(trade?.sourceOrderIds) ? trade.sourceOrderIds : []),
  ];

  for (const candidate of candidates) {
    const value = String(candidate ?? '').trim();
    const match = value.match(/^demo(?:[-_](?:tp|wt|[a-z]+(?:[-_][a-z]+)*))?(?:[-_]?order)?[-_]?0*(\d+)$/i);
    if (!match) continue;
    const demoNumber = Number(match[1]);
    if (Number.isFinite(demoNumber) && demoNumber > 0) return `Demo_${demoNumber}`;
  }

  return null;
}

export function getVisibleTradeTags(tags: unknown, demoMode: boolean, trade?: unknown): string[] {
  if (!Array.isArray(tags)) return [];
  const normalizedTags = tags.map((tag) => String(tag ?? '').trim()).filter(Boolean);
  if (!demoMode) return normalizedTags;

  const sampleTags = normalizedTags.filter((tag) => tag.toLowerCase() !== 'demo data');
  const demoDisplayId = getDemoTradeDisplayId(trade);
  const demoRowNumber = Number(demoDisplayId?.match(/(\d+)$/)?.[1]);

  if (Number.isFinite(demoRowNumber) && demoRowNumber % 6 === 0) return [];
  if (demoRowNumber === 9 || demoRowNumber === 10) return sampleTags.slice(0, 3);
  if (Number.isFinite(demoRowNumber) && demoRowNumber % 2 === 0) return sampleTags.slice(0, 1);
  return sampleTags.slice(0, 2);
}

export function renameTradeTag(tags: unknown, originalTag: string, nextTag: string): string[] {
  if (!Array.isArray(tags)) return [];
  const original = originalTag.trim();
  const replacement = nextTag.trim();
  if (!original || !replacement) return tags.map((tag) => String(tag));

  const renamed = tags.map((tag) => String(tag).trim()).map((tag) => tag === original ? replacement : tag);
  return Array.from(new Set(renamed.filter(Boolean)));
}
